module.exports = __webpack_public_path__ + "static/media/social3.133782c1.png";